import { ComponentProps, useState } from 'react';

import { t } from '@web-solutions/module-localization';


import { Skeleton } from '../skeleton';

import classes from './style.module.scss';
import { useLocale } from 'core/hooks/use-locale';

export interface ImageProps extends Omit<ComponentProps<'img'>, 'onLoad'> {
  isRtl?: boolean;
  aspectRatio?: number;
  objectFit?: 'contain' | 'cover';
  offSkeleton?: boolean;
  onLoad?: (loaded: boolean) => void;
  img?: string;
  objectPosition?: 'top' | 'center' | 'bottom';
  raw?: boolean
}

const Image: React.FC<ImageProps> = ({
  img,
  isRtl,
  className,
  aspectRatio,
  objectFit = 'contain',
  objectPosition = 'center',
  onLoad,
  raw,
  ...props
}) => {
  const { locale } = useLocale();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleLoad = () => {
    const loaded = true;
    setImageLoaded(loaded);
    onLoad?.(loaded);
  };

  return (
    <div className={className} style={{ aspectRatio, overflow: 'hidden' }}>
      {!imageLoaded && <Skeleton />}
      <img
        src={
          !raw ? (
            //@ts-ignore
          locale === 'ar' && isRtl
            ? t(`${img}.src`)?.replace('.webp', '-rtl.webp')
            : t(`${img}.src`)) : img
        }
        alt={t(`${img}.alt`)}
        style={{ objectFit, display: imageLoaded ? 'block' : 'none', objectPosition }}
        onLoad={handleLoad}
        className={classes.img}
        {...props}
      />
    </div>
  );
};

export default Image